import type { Board } from '@atlassian/jira-navigation-types/src/types.tsx';
import get from '../../rest/recent-boards/get/index.tsx';
import { transformRecentBoards } from './transformers.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default async (count: number): Promise<Board[]> => {
	const { views } = await get(count);
	return transformRecentBoards(views);
};
